export const Constants = {
  YEARLY_PAYMENT_DISCOUNT: 0.05
}
